import { render, staticRenderFns } from "./Tree.vue?vue&type=template&id=590d9e72&"
import script from "./Tree.vue?vue&type=script&lang=js&"
export * from "./Tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports